import { profileDetailsFetcher } from '@api/fetcher/ambassdor'
import { useQuery } from '@tanstack/react-query'

interface ReturnType {
  data: any
  isLoading: boolean
  error: unknown
  isFetching: any
}

const useProfileDetails = (): ReturnType => {
  const { isLoading, error, data, isFetching } = useQuery(
    ['ambassdor-profile-fetcher'],
    profileDetailsFetcher,
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  )
  return {
    error,
    isLoading,
    data: data?.data?.data,
    isFetching,
  }
}

export default useProfileDetails
